import { useEffect } from "react";
import { loadCalendly } from "../integrations/calendly";

export function CalendlyLoader() {
    useEffect(() => {
        loadCalendly().catch(() => {});
    }, []);
    return null;
}
